import { cycloneApiClient } from '@/shared/api/core/axios-instance';

import { delayDagMockMutation } from '@/entities/dag/api/_internal/dagMockDelay';
import { updateDagInMockStore } from '@/entities/dag/api/_internal/dagMockStore';
import { shouldUseDagMockApi } from '@/entities/dag/api/_internal/shouldUseDagMockApi';
import type { UpdateDagRequest, UpdateDagResponse } from '@/entities/dag/domain/types';

export const updateDagApi = async ({ dagUuid, description, tags }: UpdateDagRequest): Promise<UpdateDagResponse> => {
  if (shouldUseDagMockApi()) {
    await delayDagMockMutation('standard');
    return updateDagInMockStore({ dagUuid, description, tags });
  }

  const response = await cycloneApiClient.patch<UpdateDagResponse>(`/dags/${dagUuid}`, {
    description,
    tags,
  });

  return response.data;
};
